import { render, staticRenderFns } from "./TaskMessageIframe.vue?vue&type=template&id=5b5f2f50&"
import script from "./TaskMessageIframe.vue?vue&type=script&lang=ts&"
export * from "./TaskMessageIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports